module.exports = __webpack_public_path__ + "img/TZC.c70e0a00.svg";